import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-900 min-h-screen flex flex-col space-y-16 font-roboto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navbar = _resolveComponent("navbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_toast_on = _resolveComponent("toast-on")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_navbar),
    _createElementVNode("section", null, [
      _createVNode(_component_router_view),
      _createVNode(_component_toast_on)
    ])
  ]))
}